export default __webpack_public_path__ + "static/media/icon-close.8736b141.svg";